export default "__VITE_ASSET__CrlQkmR0__"